module.exports = require("@material/dialog/dist/mdc.dialog");


//////////////////
// WEBPACK FOOTER
// external {"root":"@material/dialog/dist/mdc.dialog","commonjs2":"@material/dialog/dist/mdc.dialog","commonjs":"@material/dialog/dist/mdc.dialog","amd":"@material/dialog/dist/mdc.dialog","umd":"@material/dialog/dist/mdc.dialog"}
// module id = 30
// module chunks = 0